export default __webpack_public_path__ + "static/media/template_business-man__0002_25---WinfredYu.5f23596f.png";